<template>
  <div>
    <reports-title
      ref="reportsTitle"
      :title="pageTitle"
    />
    <reports-toolbar
      ref="reportsToolbar"
      :report-title="pageTitle"
      :range-value="toolbarRange"
      :selected-group-list="toolbarSelectedGroupsList"
      :group-list="toolbarGroupsList"
      :toolbar-disabled="!filteredTableData.length"
      :activeReportViewMode="'table'"
      @onClickExpand="toggleAllGroups(true)"
      @onClickCollapse="toggleAllGroups(false)"
      @onSelectGroup="onSelectGroup"
      @onClickExport="onExport"
    />
    <skeleton-wrapper
      v-if="isShowSkeleton"
      id="skeletonWrapper"
      :style="{ height: contentHeight }"
    >
      <template #body>
        <skeletonTable />
      </template>
    </skeleton-wrapper>
    <report-table
      v-else
      ref="table"
      :config="tableConfig"
      :rows-data="filteredTableData"
      :grouping="grouping"
      :expand-settings="expandSettings"
      :local-storage-table-id="currentFilter.type"
      :skin="'horizontal-borders'"
      @onSortingChange="onSortingChange"
      :style="{ height: contentHeight }"
    />
  </div>
</template>

<script>
import reportsTitle from '../include/title.vue';
import reportsToolbar from '../include/toolbar.vue';
import reportTable from '../include/table/table.vue';
import reportConstants from '../include/constants';
import reportHelpers from '../include/helpers';
import timeReportsTableConfigs from '../time/configTable';
import TimelogController from '../time/controllerReportTimelogs';
import skeletonTable from '../include/table/skeleton.vue';
import Filter from '../../filter/filter';
import Export from '../include/export/export';
import skeletonWrapper from '../../common/VueComponents/skeletons/skeletonWrapper.vue';
import tableHelpers from '../include/table/helpers';

export default {

  components: {
    reportsTitle, reportsToolbar, reportTable, skeletonTable, skeletonWrapper,
  },
  data() {
    return {
      tableData: [],
      grouping: [],
      expandSettings: {
        key: 0,
        isAllExpanded: true,
      },
      toolbarRange: '',
      isMounted: false,
      contentHeight: '0px',
    };
  },

  computed: {
    currentFilter() {
      return this.$store.getters['filter/currentFilter'];
    },
    pageTitle() {
      return reportConstants.TITLE.time.timelogList;
    },
    tableGroupsList() {
      return [
        { type: 'task', label: __('group_by_task') },
        { type: 'project', label: __('group_by_project') },
        { type: 'user', label: __('group_by_user') },
        { type: 'table_date', label: __('group_by_date') },
        { type: 'table_time', label: __('group_by_time') },
      ];
    },
    toolbarGroupsList() {
      return this.tableGroupsList.filter(item => !this.grouping.includes(item.type));
    },
    toolbarSelectedGroupsList() {
      // return this.tableGroupsList.filter(item => this.grouping.includes(item.type));
      const selectedGroupsList = this.grouping.map(i => ({
        ...this.tableGroupsList.find(item => item.type === i)
      }));

      return selectedGroupsList;
    },
    tableConfig() {
      return { ...timeReportsTableConfigs.timelogList };
    },
    filteredTableData() {
      const groupedData = tableHelpers.changeTableDataByGroups(this.grouping, this.tableData);
      const { task_name, resource_id, comment } = this.currentFilter.properties;

      let filtered = reportHelpers.returnTasksByFilterText(groupedData, task_name);
      filtered = reportHelpers.returnTasksByFilterAssignee(filtered, resource_id, 'user');
      filtered = reportHelpers.returnTasksByFilterText(filtered, comment, 'comment');

      return filtered;
    },
    isShowSkeleton() {
      return !this.isMounted && !this.tableData?.length;
    },
  },

  watch: {
    'currentFilter.properties': {
      handler(newProps, oldProps) {
        if (!newProps) return;

        Filter.watchChangedFilterProps(newProps, oldProps, {
          gantt_id: this.filterData,
          portfolio_id: this.filterData,
          date: this.filterData,
          time: this.filterData,
        });
      },
      deep: true,
      immediate: false,
    },
  },

  created() {
    TimelogController.init();
  },

  mounted() {
    this.filterData();
    this.isMounted = true;
    userExtAnalytics.log('reports_time_log_list_open');
    this.calcContentHeight();
    window.addEventListener('resize', this.calcContentHeight);
  },
  beforeUnmount() {
    TimelogController.destroy();
    window.removeEventListener('resize', this.calcContentHeight);
  },

  methods: {
    calcContentHeight() {
      const viewportHeight = document.documentElement.clientHeight || window.innerHeight || 0;

      const titleRef = this.$refs.reportsTitle;
      const toolbarRef = this.$refs.reportsToolbar;

      const titleEl = titleRef && (titleRef.$el || titleRef);
      const toolbarEl = toolbarRef && (toolbarRef.$el || toolbarRef);

      const titleHeight = titleEl?.getBoundingClientRect().height || 0;
      const toolbarHeight = toolbarEl?.getBoundingClientRect().height || 0;

      const height = Math.max(viewportHeight - titleHeight - toolbarHeight, 0);

      this.contentHeight = `${height}px`;
    },
    filterData() {
      this.tableData = TimelogController.initTimelogDataByFilter(this.currentFilter);
      this.toolbarRange = reportHelpers.setToolbarRangeValue(this.currentFilter);
    },

    onSelectGroup(data) {
      userExtAnalytics.log('report_time_log_list_group_by_change', {
        by: data.type,
      });
      this.grouping = this.grouping.includes(data.type)
        ? this.grouping.filter(g => g !== data.type)
        : [...this.grouping, data.type];
    },

    toggleAllGroups(flag) {
      this.expandSettings = {
        key: ++this.expandSettings.key,
        isAllExpanded: flag,
      };
    },

    onSortingChange() {
      userExtAnalytics.log('report_time_log_list_sort_by_change');
    },

    onExport() {
      Export.exportTanstackTableDataToExcel({
        title: __(`${this.pageTitle}`),
        tableInstance: this.$refs.table?.tableController?.tableInstance,
        aggregatedColumns: this.tableConfig?.aggregatedColumns || [],
        nameTaskColumnKey: 'task',
        reportType: 'time',
      });

      userExtAnalytics.log('report_time_log_list_export_done');
    },
  },
};
</script>
